import { analytics } from '../../index'

const config = {
  domain: 'Impact',
  subdomain: 'CheckIn',
}

// eslint-disable-next-line no-shadow
export enum CheckInSurveyEvent {
  Start_Survey_Clicked = 'Start_Survey_Clicked',
  Survey_Dismissed = 'Survey_Dismissed',
  Survey_Completed = 'Survey_Completed',
}

export interface CheckInSurveyParams {
  email: string
  funderOrgId: number | null
  nonprofitOrgId: number
  platform: string
  platformPlan: string | null
  userId: number
}

export const checkIn = {
  [CheckInSurveyEvent.Start_Survey_Clicked]:
    analytics.trackCreator<CheckInSurveyParams>({
      ...config,
      eventName: 'Start_Survey_Clicked',
    }),
  [CheckInSurveyEvent.Survey_Dismissed]:
    analytics.trackCreator<CheckInSurveyParams>({
      ...config,
      eventName: 'Survey_Dismissed',
    }),
  [CheckInSurveyEvent.Survey_Completed]:
    analytics.trackCreator<CheckInSurveyParams>({
      ...config,
      eventName: 'Survey_Completed',
    }),
}
